import './Checklist.style.scss';

/**
 * Badge d'état d'une instance :
 * - vert avec un ✓ si 100 % complété et tout valide ;
 * - gris/orange sinon, avec le décompte « X ✓ - Y ✗ / Z ».
 */
const ChecklistStateBadge = ({ state }) => {
  if (!state) {
    return null;
  }
  if (state.total === 0) {
    return <span className="checklist-badge checklist-badge--empty">No question</span>;
  }
  const success = state.isComplete && state.isAllValid;
  return (
    <span
      className={`checklist-badge ${success ? 'checklist-badge--ok' : 'checklist-badge--warn'}`}
      title={`${state.answered} answered / ${state.total}`}
    >
      {success ? '✓ ' : ''}
      {state.valid} ✓ - {state.invalid} ✗ / {state.total}
    </span>
  );
};

export default ChecklistStateBadge;
